"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var PriceZoneProductPrice_1 = require("./PriceZoneProductPrice");
/**
 * Data transfer object for exporting price architecture, representing one row
 *
 * @author JMr
 */


var PriceArchitectureExportDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(PriceArchitectureExportDTO, _DomainObject_1$Domai);

  /**
   *
   * @param externalId of product
   * @param name of product
   * @param categoryLevel6
   * @param categoryLevel5
   * @param categoryLevel4
   * @param categoryLevel3
   * @param categoryLevel2
   * @param categoryLevel1
   * @param leader flag
   * @param family name
   * @param tier name
   * @param ratio of product
   * @param charger of product
   * @param flags string containing comma seperated flags of the product
   * @param supplier name
   * @param priceSensitivity name
   * @param purchasePrice purchase price of internal product
   * @param prices containing for each price zone
   *               actualRegularPrice(average of internal product of category),
   *               actualMarginPrice (difference between purchase and regular price),
   *               actualMarginPercentage (difference between purchase and regular price in %)
   *               unitPrice (actual regular price for a base unit)
   */
  function PriceArchitectureExportDTO(externalId, name, categoryLevel6, categoryLevel5, categoryLevel4, categoryLevel3, categoryLevel2, categoryLevel1, leader, family, tier, ratio, charger, flags, supplier, priceSensitivity, purchasePrice, prices) {
    var _this;

    _classCallCheck(this, PriceArchitectureExportDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PriceArchitectureExportDTO).call(this));
    _this.externalId = externalId;
    _this.name = name;
    _this.categoryLevel6 = categoryLevel6;
    _this.categoryLevel5 = categoryLevel5;
    _this.categoryLevel4 = categoryLevel4;
    _this.categoryLevel3 = categoryLevel3;
    _this.categoryLevel2 = categoryLevel2;
    _this.categoryLevel1 = categoryLevel1;
    _this.leader = leader;
    _this.family = family;
    _this.tier = tier;
    _this.ratio = ratio;
    _this.charger = charger;
    _this.flags = flags;
    _this.supplier = supplier;
    _this.priceSensitivity = priceSensitivity;
    _this.purchasePrice = purchasePrice;
    _this.prices = prices;
    return _this;
  }

  return PriceArchitectureExportDTO;
}(DomainObject_1.DomainObject);

exports.PriceArchitectureExportDTO = PriceArchitectureExportDTO;

PriceArchitectureExportDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(PriceArchitectureExportDTO.name);
  return {
    externalId: builder.str('externalId'),
    name: builder.str('name'),
    categoryLevel6: builder.str('categoryLevel6'),
    categoryLevel5: builder.str('categoryLevel5'),
    categoryLevel4: builder.str('categoryLevel4'),
    categoryLevel3: builder.str('categoryLevel3'),
    categoryLevel2: builder.str('categoryLevel2'),
    categoryLevel1: builder.str('categoryLevel1'),
    leader: builder.bool('leader'),
    family: builder.str('family'),
    tier: builder.str('tier'),
    ratio: builder.bigNum('ratio'),
    charger: builder.bigNum('charger'),
    flags: builder.str('flags'),
    supplier: builder.str('supplier'),
    priceSensitivity: builder.str('priceSensitivity'),
    purchasePrice: builder.bigNum('purchasePrice'),
    prices: builder.listOf(builder.obj('prices', PriceZoneProductPrice_1.PriceZoneProductPrice.schema, function (mat) {
      return new PriceZoneProductPrice_1.PriceZoneProductPrice(mat.priceZoneId, mat.actualRegularPrice, mat.actualMarginPrice, mat.actualMarginPercentage, mat.unitPrice);
    }))
  };
}();